(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-faq-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fb-faq')) {
    customElements.define('fb-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.input = this.querySelector('input[type="search"]');
        this.items = [...this.querySelectorAll('.fb-faq-item')];
        this.topics = [...this.querySelectorAll('[data-faq-topic]')];
        this.category = '';
        this.input.addEventListener('input', () => { this.category = ''; this.filter(); }, options);
        this.input.addEventListener('keydown', event => { if (event.key === 'Escape') { this.input.value = ''; this.category = ''; this.filter(); } }, options);
        this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.filter(); this.showAnswers(); }, options);
        this.addEventListener('click', event => {
          const topic = event.target.closest('[data-faq-topic]');
          if (topic) { this.category = this.category === topic.dataset.faqTopic ? '' : topic.dataset.faqTopic; this.input.value = ''; this.filter(); this.showAnswers(); }
          if (event.target.closest('[data-faq-reset]')) { this.input.value = ''; this.category = ''; this.filter(); this.querySelector('#fb-faq-questions-title').focus({ preventScroll: true }); }
        }, options);
        this.filter();
      }
      normalise(value) { return value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }
      filter() {
        const query = this.input.value.trim();
        const words = this.normalise(query).split(' ').filter(Boolean);
        const active = Boolean(query || this.category);
        let count = 0;
        this.items.forEach(item => {
          const text = this.normalise(item.textContent + ' ' + item.dataset.faqKeywords);
          const visible = words.length ? words.every(word => text.includes(word)) : this.category ? item.dataset.faqCategory === this.category : item.dataset.faqPopular === 'true';
          item.hidden = !visible;
          if (visible) count++;
          item.removeAttribute('data-column-break');
        });
        const visibleItems = this.items.filter(item => !item.hidden);
        if (visibleItems.length > 1) visibleItems[Math.ceil(visibleItems.length / 2) - 1].setAttribute('data-column-break', '');
        this.topics.forEach(topic => topic.setAttribute('aria-pressed', String(topic.dataset.faqTopic === this.category)));
        const topic = this.topics.find(item => item.dataset.faqTopic === this.category);
        this.querySelector('#fb-faq-questions-title').textContent = query ? 'Answers to your question' : topic ? topic.dataset.topicLabel : this.dataset.popularTitle;
        this.querySelector('[data-faq-intro]').textContent = active ? count + (count === 1 ? ' answer' : ' answers') + (query ? ' found for “' + query + '”.' : ' to help with the details.') : this.dataset.popularIntro;
        this.querySelector('[data-faq-status]').textContent = count + (count === 1 ? ' question found.' : ' questions found.');
        this.querySelector('[data-faq-reset]').hidden = !active;
        this.querySelector('.fb-faq-empty').hidden = count !== 0;
      }
      showAnswers() {
        const heading = this.querySelector('#fb-faq-questions-title');
        this.querySelector('#fb-faq-answers').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        heading.focus({ preventScroll: true });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fb-header"]) return;
  try {
    
  if (!customElements.get('fb-shell')) {
    customElements.define('fb-shell', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        document.addEventListener('click', event => {
          const close = event.target.closest('[data-fb-close]');
          if (close) { close.closest('dialog')?.close(); return; }
          const trigger = event.target.closest('[data-fb-open]');
          if (trigger) {
            const dialog = document.getElementById(trigger.dataset.fbOpen);
            if (dialog) { event.preventDefault(); this.openDialog(dialog, trigger); return; }
          }
          const link = event.target.closest('a[href]');
          if (link) {
            const url = new URL(link.href, location.href);
            if (url.origin === location.origin && url.pathname === location.pathname && url.hash.startsWith('#fb-')) {
              const dialog = document.getElementById(url.hash.slice(1));
              if (dialog instanceof HTMLDialogElement) { event.preventDefault(); document.getElementById('fb-menu')?.close(); this.openDialog(dialog, link); return; }
            }
            if (link.closest('#fb-menu, #fb-occasion-menu')) link.closest('dialog').close();
          }
          if (event.target instanceof HTMLDialogElement) {
            const r = event.target.getBoundingClientRect();
            if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
          }
        }, { signal });
        const initial = document.getElementById(location.hash.slice(1));
        if (initial instanceof HTMLDialogElement && initial.id.startsWith('fb-')) this.openDialog(initial);
        import('@shopify/events').then(({ StandardEvents }) => {
          if (signal.aborted) return;
          document.addEventListener(StandardEvents.cartLinesUpdate, event => {
            event.promise?.then(({ cart, detail }) => {
              const count = cart?.totalQuantity ?? detail?.itemCount;
              if (count != null) this.querySelectorAll('.fb-cart-count').forEach(badge => { badge.textContent = String(count); });
            }).catch(() => {});
          }, { signal });
        }).catch(() => {});
      }
      openDialog(dialog, trigger) {
        if (dialog.open) return;
        const parentDialog = trigger?.closest('dialog');
        const restoreTarget = parentDialog ? this.querySelector('[data-fb-open="fb-menu"]') : trigger;
        if (parentDialog && parentDialog !== dialog) parentDialog.close();
        dialog.showModal();
        document.body.classList.add('fb-dialog-open');
        trigger?.setAttribute('aria-expanded', 'true');
        dialog.addEventListener('close', () => {
          if (!document.querySelector('dialog[open]')) document.body.classList.remove('fb-dialog-open');
          trigger?.setAttribute('aria-expanded', 'false');
          if (restoreTarget?.isConnected && !document.querySelector('dialog[open]')) restoreTarget.focus({ preventScroll: true });
        }, { once: true });
      }
      disconnectedCallback() { this.controller?.abort(); document.body.classList.remove('fb-dialog-open'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
